import { DatePipe } from "@angular/common";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { qR } from "@angular/core/src/render3";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { CalendarTranslateService } from "app/modules/UIKit/services/calendarTranslate.service";
import { CardAssociationService, CardCustomerAssociation } from "app/services/customer/card-association.service";
import { Campaign3BreadcrumbComponent } from "app/views/campaign-3/components/campaign-3-breadcrumb/campaign-3-breadcrumb.component";
import { BreadCrumbModel } from "app/views/campaign-3/models/campaign-3-breadcrumb.model";
import { error } from "console";
import { MessageService } from "primeng/primeng";



interface CreateCardAssociationPayload {
  storeRequest: string;
  customerId: string;
  dateStart: string;
  dateEnd: string;
  cardNo: string;
  uuid: string;
}
interface FieldModel {
  qrCode: string;
  store: string;
  customer: string;
  dateRequested: Date | null;
  dateEnd: Date | null;
  cardNumber: string;
}







@Component({
  selector: 'app-new-card-association',
  templateUrl: './new-card-association.component.html',
  styleUrls: ['./new-card-association.component.css']
})
export class NewCardAssociation implements OnInit {

  @ViewChild('breadcrumbComponent') breadcrumb: Campaign3BreadcrumbComponent;
  breadcrumbs: Array<BreadCrumbModel> = [];
  showBreadCrumb: boolean = false;
  myForm: FormGroup;

  // ViewChild per i tuoi componenti personalizzati
  @ViewChild('qrCodeChild') qrCodeChild;
  @ViewChild('storeChild') storeChild;
  @ViewChild('customerChild') customerChild;
  @ViewChild('dateReqChild') dateReqChild;
  @ViewChild('dateEndChild') dateEndChild;
  @ViewChild('cardNumbChild') cardNumbChild;
  @ViewChild('cardNumbInput') cardNumbInputRef: ElementRef;



  @ViewChild('activeCardChild') activeCardChild;


  activeCardList: Array<string> = []
  displayDeleteDialog: boolean = false;
  cardNumberEnabler: boolean = true;

  formEnabler: boolean = true;
  saveEnabler: boolean = true;
  readyActiveCards: boolean = false;
  qrEnabler: boolean = false;
  uuid: string = '';

  // Modello per i dati del form
  fieldModel: FieldModel = {
    qrCode: '',
    store: '',
    customer: '',
    dateRequested: null,
    dateEnd: null,
    cardNumber: ''
  };
  cardNumberError: boolean = false;



  constructor(
    public srvCalendar: CalendarTranslateService,
    private srvNotify: MessageService,
    private translateService: TranslateService,
    public router: Router,
    private fb: FormBuilder,
    private associationService: CardAssociationService,
        private datePipe: DatePipe,
    
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.initBreadCrumbs();
  }

  private initForm() {
    this.myForm = this.fb.group({
      qrCode: ['', Validators.required],
      store: [null, Validators.required],
      customer: [null, Validators.required],
      dateRequested: [null, Validators.required],
      dateEnd: [null, Validators.required]
    });
  }

  private initBreadCrumbs() {
    this.translateService.get([
      'breadCrumb.associations',
      'breadCrumb.newAssociation'
    ]).subscribe(translations => {
      this.breadcrumbs = [
        { code: 'bc1', description: translations['breadCrumb.associations'], routerLink: '/card-association' },
        { code: 'bc2', description: translations['breadCrumb.newAssociation'], routerLink: '/card-association/new' }
      ];
      this.showBreadCrumb = true;
    });
  }



  onReset() {
    
    this.resetForm();
    this.saveEnabler = true;
    this.cardNumberEnabler = true;
    this.qrEnabler = false;
  }

  closePopupDelete() {
    
    this.displayDeleteDialog = false;
  }

  onSaveForm() {
    
    this.displayDeleteDialog = true;
  }

  //Solo dopo aver confermato procedo al vero salvataggio
  onConfirmRisKBlacklist() {
    
    this.save();
  }



  //ho cliccato uno dei link della breadcrumb
  breadcrumbClicked(breadcrumb: BreadCrumbModel) {
    if (breadcrumb.routerLink) {
      this.router.navigate([breadcrumb.routerLink]);
    } else {
      console.log("Nessuna route implementata");
    }
  }
  resetForm() {
    
    this.fieldModel.store = '';
    this.idCustomerAfterPopulate = '';
    this.fieldModel.customer = '';
    this.fieldModel.dateRequested = null;
    this.fieldModel.dateEnd = null;
    this.uuid = '';
    this.fieldModel.cardNumber = '';
    this.cardNumberError = false;
  }


  onEvaluateAssociation() {
    
    this.activeCardList = [];
    this.resetForm();
    console.log("da implementare la chiamata");
    let qrString = this.fieldModel.qrCode;

    if (qrString == null) {
      console.error("null qr code");
    } else {
      this.associationService.evaluateCardCustomerAssociation(qrString).subscribe(
        res => {
          if (res.errorMessage) {
            console.error("Errore:", res.errorMessage);
            this.populateForm(res);
            this.saveEnabler = true;
            this.cardNumberEnabler = true;
            this.readyActiveCards = false;
            this.srvNotify.add({
              severity: 'error',
              summary: this.translateService.instant('common.error'),
              detail: this.translateService.instant(res.errorMessage),
              life: 5000
            });
            this.fieldModel.cardNumber = '';

          } else {
            console.log('Risultato:', res);
            this.populateForm(res);
            this.qrEnabler = true;
            if (res && res.customerHostId !== null && res.customerHostId !== undefined) {
              this.populateActiveCard(res.customerHostId);
            } else {
              console.error('Errore: customerHostId non è valorizzato', res);
            }
            //sposto il focus sula carta
            const inputEl = this.cardNumbInputRef;
            if (inputEl && inputEl.nativeElement) {
              setTimeout(() => {
                inputEl.nativeElement.focus();
              }, 0);
            }

            this.cardNumberEnabler = false;
            this.saveEnabler = false;
            this.fieldModel.cardNumber = '';
          }
        },
        error => {
          console.error('Errore nella chiamata:', error);
          console.log("qui posso disattivare i campi");

        }
      );
    }
  }

  //filtriamo le carte per attive
  populateActiveCard(idCustomer: number) {
    
    this.associationService.findActiveCard(idCustomer).subscribe(res => {
      if (res && res.length > 0) {
        this.activeCardList = res
          .filter(element => element.flg_state === '0' && element.flagBlackList === '0')
          .map(element => element.cardNo);

        this.readyActiveCards = this.activeCardList.length > 0;
      } else {
        this.readyActiveCards = false;
      }
    });
  }





  save(): void {
    
    this.displayDeleteDialog = false;
    // I campi da validare
    const fields = [
      this.qrCodeChild,
      this.storeChild,
      this.customerChild,
      this.dateReqChild,
      this.dateEndChild,

    ];

    let allValid = true;

    // Validazione manuale dei campi
    fields.forEach((field) => {
      if (field && typeof field.performValidation === 'function') {
        field.performValidation();
        if (!field.valid) {
          allValid = false;
          console.error(`Errore nel campo: ${field.errorMessage}`);
        }
      }
    });

    // Validazione manuale input
    const cardNumber = this.fieldModel.cardNumber;
    if (!cardNumber || cardNumber.trim() === '') {
      allValid = false;
      this.cardNumberError = true;
      console.error('Errore nel campo: Numero carta vuoto');
      this.srvNotify.add({
        severity: 'error',
        summary: this.translateService.instant('common.error'),
        detail: this.translateService.instant('cardAssociation.card_number_required'),
        life: 5000
      });
    } else {
      this.cardNumberError = false;
    }



    if (allValid) {
      console.log("Tutti i campi sono validi. Salvataggio in corso...");

      const payload: CreateCardAssociationPayload = {
        storeRequest: this.fieldModel.store,
        customerId: this.idCustomerAfterPopulate,
        dateStart: this.formatDate(this.fieldModel.dateRequested),
        dateEnd: this.formatDate(this.fieldModel.dateEnd),
        cardNo: this.fieldModel.cardNumber,
        uuid: this.uuid
      };


      console.log("Dati inviati:", payload);
      this.associationService.createCardCustomerAssociationLog(payload).subscribe(
        res => {
          console.log('Log creato con successo:', res)
          this.srvNotify.add({
            severity: 'success',
            summary: this.translateService.instant('common.success'),
            detail: this.translateService.instant('cardAssociation.logAddSuccess'),
            life: 5000
          });

          this.router.navigate(['/card-association']);
        },
        error => console.error('Errore nella creazione del log:', error)
      );
    } else {
      console.error("Errore nella validazione. Verifica i campi evidenziati.");
    }
  }

  back() {
    this.router.navigate(['/card-association']);
  }




  idCustomerAfterPopulate = ''
  populateForm(res: CardCustomerAssociation) {
    
    this.fieldModel.store = res.storeRequest;
    this.idCustomerAfterPopulate = res.customerId.toString();

    let fullCustomer = res.customerId.toString();
    if (res.fullNameCustomer) {
      fullCustomer += ' - ' + res.fullNameCustomer;
    }

    this.fieldModel.customer = fullCustomer;
    this.fieldModel.dateRequested = this.parseDate(res.dateStart);
    this.fieldModel.dateEnd = this.parseDate(res.dateEnd);
    this.uuid = res.uuid;
  }

  private parseDate(dateStr: string): Date | null {
    if (!dateStr) return null; // Evita errori su valori null o undefined
    const parts = dateStr.split('-'); // Divide "YYYY-MM-DD"
    return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2])); // Mese inizia da 0
  }
private formatDate(date: Date): string {
  let result = '';

  if (date) {
    const transformed = this.datePipe.transform(date, 'yyyy-MM-dd');
    if (transformed !== null) {
      result = transformed;
    }
  }

  return result;
}



}




// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/card-association/new-card-association/new-card-association.component.ts